// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectDatabaseEmulator, getDatabase } from "firebase/database";

const firebaseConfigEnv = {
  development: {
    apiKey: "AIzaSyCEmFFQogXZhTCkpxH60Md8qAIzUmW0q8Q",
    authDomain: "dev-conectasuite.firebaseapp.com",
    databaseURL: "https://dev-conectasuite.firebaseio.com",
    projectId: "dev-conectasuite",
    storageBucket: "dev-conectasuite.appspot.com",
    messagingSenderId: "950476866450",
    appId: "1:950476866450:web:87fcd530f7c4892781f74b",
    measurementId: "G-N5YXS7F90G",
  },
  production: {
    apiKey: "AIzaSyCVIMQ-HESCI8kFFkVHbvQpk2CG2BZRztI",
    authDomain: "conectasuite.firebaseapp.com",
    databaseURL: "https://conectasuite.firebaseio.com",
    projectId: "conectasuite",
    storageBucket: "conectasuite.appspot.com",
    messagingSenderId: "266221667666",
    appId: "1:266221667666:web:53be5ad5463493359f268b",
    measurementId: "G-GPVRMVKP8R",
  },
};

const environment = process.env.NODE_ENV || "development";

const firebaseConfig =
  firebaseConfigEnv[environment] || firebaseConfigEnv["development"];

const emulatorAuthDomain = process.env.VUE_APP_AUTH_DOMAIN || "";

if (emulatorAuthDomain) {
  firebaseConfig.authDomain = emulatorAuthDomain;
}

// Initialize Firebase

const app = initializeApp(firebaseConfig);

if (
  (location?.hostname === "localhost" || location?.hostname === "127.0.0.1") &&
  process.env.VUE_APP_USE_FIREBASE_AUTH_EMULATOR
) {
  connectAuthEmulator(getAuth(app), firebaseConfig.authDomain, {
    disableWarnings: true,
  });
  const databaseUrl = process.env.VUE_APP_DATABASE_URL || "";
  connectDatabaseEmulator(getDatabase(app), ...databaseUrl.split(":"));
}
